import { render, staticRenderFns } from "./DefaultHeader.vue?vue&type=template&id=7a68672a&"
import script from "./DefaultHeader.vue?vue&type=script&lang=js&"
export * from "./DefaultHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7a68672a')) {
      api.createRecord('7a68672a', component.options)
    } else {
      api.reload('7a68672a', component.options)
    }
    module.hot.accept("./DefaultHeader.vue?vue&type=template&id=7a68672a&", function () {
      api.rerender('7a68672a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/containers/DefaultHeader.vue"
export default component.exports